'use strict'

import Router from 'vue-router'
import takeOffTool from './take-off-tool'
import project from './project'
import projectAudit from './project-audit'
import checkout from './checkout'
import login from './login'
import myAccount from './my-account'
import pageNotFound from './page-not-found'
import { authGuard } from './auth-guard'

const appRoutes = [
	{
		path: '/',
		name: 'Main',
		redirect: {
			name: 'project.list'
		}
	},
	{ path: '*', component: pageNotFound }
].concat(login, project, takeOffTool, projectAudit, checkout, myAccount)

const appRouter = new Router({ mode: 'history', routes: appRoutes })

appRouter.beforeEach(authGuard)

export default appRouter



// WEBPACK FOOTER //
// ./src/app/router.js